import { Effect, Layer, Scope } from "effect";
import { AtomRegistry } from "effect/unstable/reactivity";
import { ChatApi } from "../api/chat/service.ts";
import { AcceptedWork } from "../state/accepted-work.ts";
import { QueryWork } from "../state/query-work.ts";
import { makeSessionOwner } from "../state/session-owner.ts";
import { makeChatController } from "./operations.ts";
import { makeChatActions } from "./actions.ts";
import { ChatBrowserIo, ChatSessions } from "./service.ts";
export const ChatSessionsLive = (root: Scope.Scope) => Layer.effect(ChatSessions, Effect.gen(function* () {
  const sessions = yield* makeSessionOwner(root);
  const ports = { api: yield* ChatApi, accepted: yield* AcceptedWork, queryWork: yield* QueryWork,
    registry: yield* AtomRegistry.AtomRegistry, browser: yield* ChatBrowserIo };
  return ChatSessions.of({ open: sessions.open(makeChatController(root, ports).pipe(Effect.map(makeChatActions))) });
}));
export const ChatBrowserIoLive = Layer.succeed(ChatBrowserIo, ChatBrowserIo.of({ linkedThread: Effect.sync(() =>
  typeof window === "undefined" ? null : new URLSearchParams(window.location.search).get("thread")) }));
